import * as yup from "yup";
import { ContentCarouselSchema, ContentHeroSchema, ContentLinkListSchema, ContentTextSchema } from "./";
import { ContentBlockTypes } from "../../domain/ContentBlockTypes";
import * as M from "../../models";

export interface ContentBlockData {
    deleted: boolean;
    id: number;
    index: number;
    label?: string;
    typeId: number;
    type: string;
}

export const ContentBlockSchema = yup.object<ContentBlockData>().shape({
    deleted: yup.bool(),
    id: yup.number().required().label("ID").min(0, "Invalid ID"),
    index: yup.number(),
    typeId: yup.number().required().label("Type ID").min(0, "Invalid type ID"),
    type: yup.string().required().label("Type"),
});

export const getContentBlockSchema = yup.lazy((cb: M.Page.ContentBlock) => {
    // TODO: Update this for every new content block type
    if (cb && cb.typeId === ContentBlockTypes.Carousel.id)
        return ContentCarouselSchema;
    else if (cb && cb.typeId === ContentBlockTypes.Hero.id)
        return ContentHeroSchema;
    else if (cb && cb.typeId === ContentBlockTypes.LinkList.id)
        return ContentLinkListSchema;
    else if (cb && cb.typeId === ContentBlockTypes.Text.id)
        return ContentTextSchema;
    return ContentBlockSchema
        .concat(ContentCarouselSchema as any)
        .concat(ContentHeroSchema as any)
        .concat(ContentLinkListSchema as any)
        .concat(ContentTextSchema as any);
});



// WEBPACK FOOTER //
// ./src/forms/adminPage/ContentBlock.ts